import { httpsCallable } from 'firebase/functions';
import { functions } from '.';
import logger from '../utils/logger';
import { getErrorMessage } from '../utils/errorUtils';

// MUST stay above `recordnewdashboardtutorialstatus`'s own `timeoutSeconds` (20s): a server budget longer
// than the client's leaves the abandoned execution alive after the client has given up
const RECORD_NEW_DASHBOARD_TUTORIAL_STATUS_TIMEOUT = 30000;

/**
 * Records the patient's tutorial outcome on their own profile. Answers `{ recorded: false }` rather than
 * throwing: the caller is a fire-and-forget thunk, and a failed write must not disturb a tour that has
 * already ended for the patient. The failure is logged.
 *
 * @param {object} params
 * @param {string} params.userId - Profile to write.
 * @param {string} params.status - One of NEW_DASHBOARD_TUTORIAL_STATUSES.
 * @returns {Promise<{recorded: boolean}>}
 */
export const recordNewDashboardTutorialStatus = async ({ userId, status }) => {
    const func = httpsCallable(functions, 'recordnewdashboardtutorialstatus', { timeout: RECORD_NEW_DASHBOARD_TUTORIAL_STATUS_TIMEOUT });

    try {
        const result = await func({ userId, status });

        return { recorded: result?.data?.recorded === true };
    } catch (error) {
        logger.logErrorEvent('RECORD_NEW_DASHBOARD_TUTORIAL_STATUS', error, getErrorMessage(error), true);

        return { recorded: false };
    }
};
